import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { usePageMeta } from '@/hooks/usePageMeta';

const values = [
  {
    icon: 'ri-compass-3-line',
    title: '内容发现',
    text: '围绕热门与最新影视作品，提供分类浏览、筛选排序与相关推荐，帮助用户快速找到想看的内容。',
  },
  {
    icon: 'ri-newspaper-line',
    title: '行业资讯',
    text: '汇集影视行业动态、剧集观察与影展资讯，以客观、清晰的方式呈现影视圈正在发生的事。',
  },
  {
    icon: 'ri-device-line',
    title: '多端体验',
    text: '电脑端与手机端均经过适配，导航、筛选、搜索与详情浏览都能获得流畅一致的体验。',
  },
];

const notices = [
  '本站为影视内容介绍与资讯展示平台，不提供在线播放、下载与支付功能。',
  '站内影视作品、资讯文章及相关人物均为演示示例，仅用于展示产品效果。',
  '收藏功能基于浏览器本地存储实现，为前端演示，不做服务端同步。',
  '如需引用站内内容，请注明来源；内容相关问题可通过下方邮箱反馈。',
];

export default function AboutPage() {
  usePageMeta({
    title: '关于我们 - 河马AV影视内容平台',
    description:
      '了解河马AV的网站定位、服务宗旨与联系方式。河马AV是聚焦影视内容介绍与行业资讯的专业影视门户。',
    keywords: '关于河马AV,影视平台介绍,联系方式,河马AV',
  });

  return (
    <Layout>
      <section className="border-b border-background-200 bg-background-50">
        <div className="mx-auto max-w-5xl px-4 py-8 md:px-6 md:py-12">
          <Breadcrumb items={[{ label: '关于我们' }]} />
          <h1 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            关于河马AV
          </h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-500 md:text-base">
            河马AV 是聚焦影视内容介绍与行业资讯的专业影视门户，致力于为影视爱好者、行业从业者与普通观众
            提供清晰、易用的内容发现体验。
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-5xl px-4 py-10 md:px-6 md:py-14">
        {/* Positioning */}
        <section>
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
            <span className="h-6 w-1.5 rounded-full bg-accent-500" />
            网站定位
          </h2>
          <p className="mt-4 text-sm leading-loose text-foreground-700 md:text-[15px]">
            河马AV 将影视资源介绍、行业动态资讯与推荐内容集中于一处，帮助用户高效获取最新影视作品信息、
            浏览影评与推荐、了解行业新闻。我们希望成为影迷日常浏览与内容发现的第一站，
            以专业、现代且易用的门户形态，陪伴每一次观影选择。
          </p>
        </section>

        {/* Values */}
        <section className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
          {values.map((value) => (
            <div key={value.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-xl text-primary-600">
                <i className={value.icon} />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{value.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-500">{value.text}</p>
            </div>
          ))}
        </section>

        {/* Notice */}
        <section className="mt-12">
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
            <span className="h-6 w-1.5 rounded-full bg-secondary-500" />
            使用须知
          </h2>
          <ul className="mt-4 flex flex-col gap-3">
            {notices.map((notice) => (
              <li key={notice} className="flex gap-3 text-sm leading-relaxed text-foreground-700">
                <i className="ri-checkbox-circle-line mt-0.5 text-secondary-500" />
                <span>{notice}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* Contact */}
        <section className="mt-12 rounded-lg bg-primary-950 p-6 md:p-8">
          <h2 className="font-heading text-xl font-bold text-background-50">联系我们</h2>
          <p className="mt-3 text-sm leading-relaxed text-primary-200">
            如对内容、合作或产品有任何建议，欢迎通过以下方式与我们联系，我们会尽快回复。
          </p>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div className="flex items-center gap-3 rounded-md bg-primary-900 px-4 py-3">
              <i className="ri-mail-line text-xl text-accent-400" />
              <div>
                <p className="text-xs text-primary-300">内容与反馈邮箱</p>
                <p className="font-label text-sm text-background-50">contact@hema-av.example</p>
              </div>
            </div>
            <div className="flex items-center gap-3 rounded-md bg-primary-900 px-4 py-3">
              <i className="ri-time-line text-xl text-accent-400" />
              <div>
                <p className="text-xs text-primary-300">内容更新时间</p>
                <p className="font-label text-sm text-background-50">每日 09:00 / 18:00</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
}